import React, { useState } from "react";
import {
  sendPasswordPgw,
  loginToken,
  setUserEntry,
  sendPasswordVerify,
  confirmPasswordReset,
} from "../../server/Customer";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import Input from "../containers/InputForm";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import showAlert from "../../server/ShowAlert";

const schema = yup
  .object({
    userName: yup.string().required("שדה חובה").trim(),
    password: yup
      .string()
      .required("חובה להכניס סיסמה")
      .matches(/[a-zA-Z]/, "חייב להכיל אותיות באנגלית")
      .matches(/[0-9.,-]/, "חייב להכיל לפחות מספר או תו מיוחד")
      .min(8, "לפחות 8 תווים")
      .max(72, "מקסימום 72 תווים"),
  })
  .required();

const resetSchema = yup.object({
  newPassword: yup
    .string()
    .required("חובה להכניס סיסמה")
    .matches(/[a-zA-Z]/, "חייב להכיל אותיות באנגלית")
    .matches(/[0-9.,-]/, "חייב להכיל לפחות מספר או תו מיוחד")
    .min(8, "לפחות 8 תווים")
    .max(72, "מקסימום 72 תווים"),
  confirmPassword: yup
    .string()
    .required("חובה לאשר סיסמה")
    .oneOf([yup.ref("newPassword")], "הסיסמאות לא תואמות"),
});

const UserLogin = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    register: registerReset,
    handleSubmit: handleSubmitReset,
    formState: { errors: resetErrors },
  } = useForm({
    resolver: yupResolver(resetSchema),
  });

  const [email, setEmail] = useState("");
  const [forgotPass, setForgotPass] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [userId, setUserId] = useState(null);
  const [maxAttempts, setMaxAttempts] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [validationCode, setValidationCode] = useState("");
  const [isVerified, setIsVerified] = useState(false);

  const sendPass = () => {
    sendPasswordPgw(email.trim().toLowerCase())
      .then((res) => {
        setUserId(res.userId);
        setMaxAttempts(res.maxAttempts);
      })
      .catch((e) => console.log(e));
  };

  const verify = () => {
    if (attempts <= maxAttempts) {
      sendPasswordVerify(validationCode, userId)
        .then(() => {
          showAlert({
            msgTitle: "האימייל אומת בהצלחה",
            msgType: "success",
          });
          setIsVerified(true);
        })
        .catch((e) => console.log(e));

      setAttempts((prev) => prev + 1);
    } else {
      showAlert({
        msgTitle: "ניסית יותר מדי פעמים. נסה שוב מאוחר יותר",
        msgType: "error",
      });
    }
  };

  const confirmPass = (data) => {
    confirmPasswordReset(userId, validationCode, data.newPassword)
      .then(() => {
        showAlert({
          msgTitle: "הסיסמה עודכנה בהצלחה",
          msgType: "success",
        });
        setForgotPass(false);
        setIsVerified(false);
      })
      .catch((e) => console.log(e));
  };

  const signIn = (data) => {
    data.userName = data.userName.trim().toLowerCase();
    data["grant_type"] = "password";
    dispatch(loginToken(data, true));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleShowConfirmPassVisibility = () => {
    setShowConfirmPass(!showConfirmPass);
  };

  return !forgotPass ? (
    <form className="login-form" onSubmit={handleSubmit(signIn)}>
      <Input
        errors={errors}
        label="דואר אלקטרוני"
        type="text"
        name="userName"
        register={register}
      />

      <Input
        type={showPassword ? "text" : "password"}
        errors={errors}
        label="סיסמה"
        name="password"
        register={register}
      />

      <span onClick={togglePasswordVisibility} className="password-toggle">
        {showPassword ? (
          <i className="fa fa-eye-slash"></i>
        ) : (
          <i className="fa fa-eye"></i>
        )}
      </span>

      <button className="login-btn" type="submit">
        כניסה &gt;
      </button>

      <span onClick={() => setForgotPass(true)} className="forgot-pass">
        שכחת את הסיסמה?
      </span>

      <button className="cancel" onClick={() => dispatch(setUserEntry(false))}>
        כניסה ללא הרשמה&gt;
      </button>
    </form>
  ) : (
    <div className="forgot-pass-wrap">
      {!userId ? (
        <>
          <p>אנא הקלד את כתובת המייל לאיפוס סיסמה</p>
          <input
            type="text"
            onChange={(e) => setEmail(e.target.value)}
            placeholder="אימייל"
            value={email}
          />
          <button className="send-btn" onClick={sendPass}>
            שלח
          </button>
        </>
      ) : !isVerified ? (
        <>
          <p>אנא הקלד את הקוד שקיבלת</p>
          <input
            type="text"
            onChange={(e) => setValidationCode(e.target.value)}
            placeholder="קוד אימות"
            value={validationCode}
          />
          <button className="send-btn" onClick={verify}>
            שלח
          </button>
        </>
      ) : (
        <form onSubmit={handleSubmitReset(confirmPass)}>
          <Input
            type={showPassword ? "text" : "password"}
            name="newPassword"
            label="סיסמה חדשה"
            className="password-input"
            toggleVisibility={togglePasswordVisibility}
            register={registerReset}
            errors={resetErrors}
            showPassword={showPassword}
            isPasswordField
          />

          <Input
            type={showConfirmPass ? "text" : "password"}
            name="confirmPassword"
            label="אימות סיסמה"
            toggleVisibility={toggleShowConfirmPassVisibility}
            register={registerReset}
            errors={resetErrors}
            showPassword={showConfirmPass}
            isPasswordField
          />

          <button className="send-btn" type="submit">
            שלח
          </button>
        </form>
      )}
    </div>
  );
};

export default UserLogin;
